import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import * as Yup from 'yup';
import { useNavigate, useParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import Button from '../components/Button'
import '../assets/languages/i18n'
import { Box, Grid, Link, Paper, TextField, Toolbar, Typography, InputAdornment, Alert, Collapse } from "@mui/material";
import { Formik } from "formik";
import LoginBG from "../../src/assets/images/bg.svg"
import LoginLogo1 from "../../src/assets/images/login/design-stats-pana-2.png"
import UnderConLogo from "../../src/assets/images/login/under-construction.png"
import { fetchStartParam } from "../actions/start";
import { useDispatch, useSelector } from "react-redux";
import AuthService from "../services/auth.service";
import { useCookies } from 'react-cookie';
import { makeStyles } from "@mui/styles";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import IconButton from "@mui/material/IconButton";
import CloseIcon from '@mui/icons-material/Close';

const styles = {
    toolBar: {
        paddingLeft: "5px",
    },
    childToolBar: {
        padding: "32px 20px",
        fontWeight: '400'
    },
    title: {
        paddingBottom: "15px"
    },
    subTitle: {
        color: "#282C40 !important"
    },
};

const useStyles = makeStyles({
    error: {
        color: " #CC6058 !important",
        "& div > p": {
            color: " #CC6058 !important",
            fontSize: "14px",
            lineHeight: "15.4px",
            marginLeft: 0,
        },
        "& > p": {
            color: " #CC6058 !important",
            fontSize: "14px",
            lineHeight: "15.4px",
            marginLeft: 0,
        },
        "& div > input": {
            fontSize: "14px",
            lineHeight: "15.4px",
        },
        "& div > label": {
            color: "#0C2B34",
            fontSize: "16px",
            lineHeight: "17.6px",
            fontWeight: "500"
        },
    },
});

const ResetView = () => {
    // getData();
    const [cookies, setCookie] = useCookies(['member']);
    const classes = useStyles()
    const navigate = useNavigate();
    const { t } = useTranslation()
    let { site } = useParams()
    const dispatch = useDispatch();
    const Start = {
        data: {
            configuration: {
                username: 'emails',
                maintenance: false,
            }
        }
    };//useSelector((state) => state.Start);
    // Start?.data?.configuration?.username === 'emails'
    const vBackHome = '/nida'//Start?.data?.configuration?.forget_password ? JSON.parse(Start.data.configuration.forget_password).value : "";
    useEffect(() => {
        var getSite = localStorage.getItem("site")
        dispatch(fetchStartParam(getSite ? getSite : "iamconsulting"))
    }, []);
    const [showPassword, setShowPassword] = useState(false);
    const [loginState, setLoginState] = useState(false);
    const [expireAlert, setExpireAlert] = useState(true);
    const handleClickShowPassword = () => setShowPassword(!showPassword);
    const handleMouseDownPassword = () => setShowPassword(!showPassword);
    const handleClick = () => {
        setShowPassword(prev => !prev);
    }

    /*** control logic  */
    console.log('start = ', Start)

    return (
        <>
            <Helmet>
                <title>Login | PMS</title>
            </Helmet>
            {/*<Box height={1} sx={{}}>*/}
            <Grid container sx={{
                height: '100%',
                'backgroundImage': `url(${LoginBG})`,
                'background-size': 'cover'
            }}>
                <Grid container item
                    sx={{
                        display: 'flex',
                        flexDirection: { xs: 'column', lg: 'row' },
                        alignItems: 'center',
                        overflow: 'hidden',
                        boxShadow: 0,
                        fontWeight: 'bold',
                    }}>
                    <Grid container item xs={12} lg={6} justifyContent="center"
                        sx={{ display: { sm: 'none', lg: 'flex' } }} alignItems="center">
                        <img src={LoginLogo1} />
                    </Grid>
                    <Grid container item xs={12} lg={6} spacing={4} sx={{}}>
                        <Grid direction="column" sx={{}}
                            container item
                            justifyContent="center"
                            alignItems="center">
                            {Start?.data?.configuration?.maintenance ?
                                (<Grid container item>
                                    <Grid container item sx={{}}>
                                        <Paper elevation={6} sx={{ padding: '50px' }}>
                                            <img src={UnderConLogo} />
                                            <Typography variant="h1" align="center">{t('login.msg.underconMsg1')}</Typography>
                                            <Typography align="center">{t('login.msg.underconMsg2')}</Typography>
                                        </Paper>
                                    </Grid>
                                </Grid>)
                                :
                                (
                                    <Grid container item sx={{}}>
                                        <Paper elevation={6} sx={{ padding: '50px', 'border-radius': '20px' }} classes={{ root: classes.error }}>
                                            <Formik
                                                // initialValues={{
                                                //     username: 'chorchujai.san@nida.ac.th',
                                                //     password: 'Chorchujai00'
                                                // }}

                                                initialValues={{
                                                    password: '',
                                                    confirm: ''
                                                }}
                                                validationSchema={Yup.object().shape(
                                                    {
                                                        password: Yup.string()
                                                            .required(t('login.msg.password_not_secure'))
                                                    }
                                                )}
                                                onSubmit={(values, { setSubmitting, setErrors, setStatus, resetForm }) => {
                                                    console.log('send api to reset password')
                                                    setSubmitting(false)
                                                    if (values.password != values.confirm) {
                                                        setErrors({
                                                            confirm: t('login.msg.password_not_match'),
                                                        })
                                                    }
                                                    // AuthService.login(
                                                    //     values.password,
                                                    //     values.confirmPassword).then(
                                                    //         (response) => {
                                                    //             setCookie('member', response.data.data);
                                                    //             if (response.data.data.consent === true) {
                                                    //                 navigate('/kpi/home', { replace: false });
                                                    //             } else {
                                                    //                 navigate('/consent', { replace: false });
                                                    //             }
                                                    //         },
                                                    //         (response) => {

                                                    //             setStatus({ success: false })
                                                    //             setSubmitting(false)

                                                    //             // const vErrorUser = "login.msg.user_not_found_in_pms"
                                                    //             // const vErrorPass = "login.msg.cannot_login_ad"

                                                    //             const vErrorUser = "login.msg.wrongemail"
                                                    //             const vErrorPass = "login.msg.wrongpassword"

                                                    //             if (response?.data?.message?.code?.Code === vErrorUser) {

                                                    //                 setErrors({
                                                    //                     username: t('login.msg.user_not_found_in_pms'),
                                                    //                 })
                                                    //             }
                                                    //             if (response?.data?.message?.code?.Code === vErrorPass) {

                                                    //                 setErrors({
                                                    //                     password: t('login.msg.cannot_login_ad')
                                                    //                 })
                                                    //             }


                                                    //         }
                                                    //     )
                                                }}
                                            >
                                                {({
                                                    errors,
                                                    handleBlur,
                                                    handleChange,
                                                    handleSubmit,
                                                    isSubmitting,
                                                    touched,
                                                    values
                                                }) => (
                                                    <form onSubmit={handleSubmit} sx={{
                                                        '& .MuiTextField-root': { m: 1, width: '25ch' },
                                                    }}>
                                                        <Box sx={{ mb: 3 }}>

                                                            <Typography
                                                                color="primary"
                                                                variant="h2"
                                                                style={styles.title}
                                                                fontSize={36}
                                                                lineHeight="39.6px"
                                                            >
                                                                {t('login.label.setPassword')}

                                                            </Typography>
                                                            <Typography
                                                                color="textSecondary"
                                                                gutterBottom
                                                                variant="h2"
                                                                style={styles.subTitle}
                                                                fontSize={16}
                                                                fontWeight={300}
                                                                lineHeight="17.6px"
                                                            >
                                                                {t('login.label.setPasswordDesc')}
                                                            </Typography>
                                                        </Box>
                                                        <TextField
                                                            error={Boolean(touched.password && errors.password)}
                                                            fullWidth
                                                            helperText={touched.password && errors.password}
                                                            label={t("login.label.inputPassword")}
                                                            margin="normal"
                                                            name="password"
                                                            onBlur={handleBlur}
                                                            onChange={handleChange}
                                                            // type="password"
                                                            value={values.password}
                                                            variant="standard"
                                                            InputLabelProps={{
                                                                shrink: true,
                                                            }}
                                                            placeholder={t('login.label.holderUsername')}
                                                            type={showPassword ? "text" : "password"} // <-- This is where the magic happens
                                                        // onChange={handleClick}
                                                        // InputProps={{ // <-- This is where the toggle button is added.
                                                        //     endAdornment: (
                                                        //     <InputAdornment position="end">
                                                        //         <IconButton
                                                        //         aria-label="toggle password visibility"
                                                        //         onClick={handleClickShowPassword}
                                                        //         onMouseDown={handleMouseDownPassword}
                                                        //         >
                                                        //         {showPassword ? <Visibility /> : <VisibilityOff />}
                                                        //         </IconButton>
                                                        //     </InputAdornment>
                                                        //     )
                                                        // }}
                                                        />
                                                        <TextField
                                                            error={Boolean(touched.confirm && errors.confirm)}
                                                            fullWidth
                                                            helperText={touched.confirm && errors.confirm}
                                                            label={t("login.label.inputPassword2")}
                                                            margin="normal"
                                                            name="confirm"
                                                            onBlur={handleBlur}
                                                            onChange={handleChange}
                                                            // type="password"
                                                            value={values.confirm}
                                                            variant="standard"
                                                            InputLabelProps={{
                                                                shrink: true,
                                                            }}
                                                            placeholder="ยืนยันรหัสผ่านใหม่"
                                                            type={showPassword ? "text" : "password"} // <-- This is where the magic happens
                                                        // onChange={handleClick}
                                                        // InputProps={{ // <-- This is where the toggle button is added.
                                                        //     endAdornment: (
                                                        //     <InputAdornment position="end">
                                                        //         <IconButton
                                                        //         aria-label="toggle password visibility"
                                                        //         onClick={handleClickShowPassword}
                                                        //         onMouseDown={handleMouseDownPassword}
                                                        //         >
                                                        //         {showPassword ? <Visibility /> : <VisibilityOff />}
                                                        //         </IconButton>
                                                        //     </InputAdornment>
                                                        //     )
                                                        // }}
                                                        />
                                                        <Grid ittem pt={2}>
                                                            <Button
                                                                color="primary"
                                                                disabled={isSubmitting}
                                                                fullWidth
                                                                size="large"
                                                                type="submit"
                                                                variant="contained"
                                                            >
                                                                {t('login.label.setPassword')}
                                                            </Button>
                                                        </Grid>
                                                        <Grid container direction={"row"} sx={{ justifyContent: 'center' }}>
                                                            <Grid item pb={2} pt={2}>
                                                                <Typography fontSize={14} lineHeight="15.4px" fontWeight={500}>
                                                                    <Link color="textSecondary" href={vBackHome}>
                                                                        {t('consent.label.backToLogin')}
                                                                    </Link>
                                                                </Typography>
                                                            </Grid>
                                                        </Grid>
                                                    </form>
                                                )}
                                            </Formik>
                                        </Paper>
                                    </Grid>)}
                            <Grid container item sx={{}}>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>

                {/*footer*/}
                <Grid container item sx={{
                    bottom: 0
                }}
                >
                    <Toolbar color="primary" sx={{ 'align-items': 'end', 'padding-left': '5px' }} style={styles.toolBar}>
                        <Typography variant="h6" component="div" sx={{ flexGrow: 0 }} p={4} style={styles.childToolBar}>
                            Copyright 2021 I AM Consulting Co., Ltd. All Rights Reserved
                        </Typography>
                        <Typography variant="h6" component="div" sx={{ flexGrow: 0 }} p={4} style={styles.childToolBar}>
                            Privacy Policy
                        </Typography>
                        <Typography variant="h6" component="div" sx={{ flexGrow: 0 }} p={4} style={styles.childToolBar}>
                            Terms of Service
                        </Typography>
                    </Toolbar>
                </Grid>
            </Grid>
            {/*</Box>*/}
        </>
    );
};
export default ResetView;
